/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { useMemo, useState } from 'react';
import {
    Button,
    FlexCol,
    FlexRow,
    FocusOnMount,
    Heading,
    useBreakpoint,
} from 'sarsaparilla';
import { gnoment } from 'shared-ui/gnoment';
import { PassType } from '../../types/PassType';
import PassRatesModal from './PassRatesModal';

interface SitePassSelectionHeadingAndFeesProps {
    facilityName?: string;
    passTypes?: PassType[];
}

export default function SitePassSelectionHeadingAndFees({
    facilityName,
    passTypes = [],
}: SitePassSelectionHeadingAndFeesProps) {
    const [isOpen, setIsOpen] = useState(false);
    const breakpoint = useBreakpoint();

    const hasFutureRates = useMemo(() => {
        return passTypes?.some((passType) =>
            passType?.periods?.some((period) =>
                gnoment().isBefore(gnoment(period.start_date))
            )
        );
    }, [passTypes]);

    return (
        <>
            <FlexRow justifyContent="space-between" hasGutters={false}>
                <FlexCol lg={9} md={12}>
                    <FocusOnMount>
                        <Heading appearance="h5" headingLevel={2}>
                            {`All Site Passes available at ${facilityName}`}
                        </Heading>
                    </FocusOnMount>
                </FlexCol>
                {hasFutureRates && (
                    <FlexCol lg={3} alignSelf="end">
                        <FlexRow justifyContent="end" hasGutters={false}>
                            <Button
                                className={
                                    breakpoint?.isMdAndDown ? 'mt-2 mb-2' : undefined
                                }
                                appearance="primary"
                                size="sm"
                                onClick={() => setIsOpen(true)}
                                shouldFitContainer={breakpoint?.isMdAndDown}
                            >
                                View Future Fees
                            </Button>
                        </FlexRow>
                    </FlexCol>
                )}
            </FlexRow>
            <PassRatesModal
                passTypes={passTypes}
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
            />
        </>
    );
}
